import React from 'react';
import { cn } from "@/lib/utils";

interface TimeColumnProps {
	timeSlots: Array<{ hour: number; minutes: number }>;
	formatTimeLabel: (hour: number, minutes: number) => string;
}

export const TimeColumn = ({ timeSlots, formatTimeLabel }: TimeColumnProps) => {
	return (
		<div className="border-r border-white/20 dark:border-white/10 sticky left-0 bg-white/60 dark:bg-black/40 backdrop-blur-sm z-10">
			{timeSlots.map(({ hour, minutes }, index) => (
				<div 
					key={`${hour}-${minutes}`} 
					className={cn(
						"h-8 relative",
						index === 0
							? "border-t border-white/20 dark:border-white/10"
							: minutes === 0 
								? "border-t border-white/20 dark:border-white/10" 
								: "border-t border-dotted border-white/10 dark:border-white/5"
					)}
				>
					{minutes === 0 && (
						<span className="text-sm text-foreground/70 absolute -translate-y-1/2 pl-2">
							{formatTimeLabel(hour, 0)}
						</span>
					)}
				</div>
			))}
		</div>
	);
};
